// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote__29oZs","shown":"shown__9qsoX"};